module.exports = __webpack_public_path__ + "static/media/EPR-loop-white-color.7f12733d.png";